import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { messageAction } from '../../_actions';
import { getUser, getPersonId, isPatient } from '../../_helpers/authorized';
import IconButton from '@material-ui/core/IconButton';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import Tooltip from '@material-ui/core/Tooltip';
import { messageConstant } from '../../_constants';
import { formatDateTime, uploadBucket, getS3ImageUrl, formatDateTimeDisplayInEmr } from '../../_helpers';
import { FileUploader } from '../../components';
import { multilineText } from '../../_helpers';
import { CustomImage } from '../../components';
import { compose } from 'recompose';
import { noteService } from '../../_services';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';


const styles = () => ({
    progress: {
        marginTop: 20,
        color: blue[500],
    }
});


class ReplyMessage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen :true,
            isOpenPopUp: true,
        };
    }

    componentDidMount(){
        const personId = this.props.match.params.personId;
        const id = this.props.match.params.msgId;
        const { dispatch } = this.props;
        dispatch(messageAction.getMessage(id, personId));
  
    }

    // componentDidUpdate(prevProps){
       
    //     if(prevProps.isReplied != this.props.isReplied){
    //         this.setState({isOpenPopUp: this.props.isReplied})
    //     }
    // }

    handleReply = () => {
        const { dispatch } = this.props;
        dispatch(messageAction.reply());
    }

    handleDiscard = () => {
         this.setState({isOpen:false});
    }

    handleChange = event => {
        const { dispatch, sendMessageObj } = this.props;

        sendMessageObj.message = event.target.value;

        // dispatch messageAction change
        dispatch(messageAction.change(sendMessageObj));
    };

    /**
     * Get the file on the input file
     */
    changeFile = (files) => {
        const { dispatch, sendMessageObj } = this.props;
        sendMessageObj.files = files;
        dispatch(messageAction.change(sendMessageObj));
    }

    handleSendReplyByLink = (event) => {

        event.preventDefault();
        const { dispatch, sendMessageObj } = this.props;
        let personId = this.props.match.params.personId;
        let id = this.props.match.params.msgId;
        const from = personId;
        
        const textToEmr = sendMessageObj.message + `\n\n[Patient message received using AskMedication.com on ${formatDateTimeDisplayInEmr(Date.now())}]`

        dispatch(messageAction.sendReplyByLink(id, from, sendMessageObj.message, sendMessageObj.files, textToEmr));
        this.setState({
            isOpen:false
        });
    }

    handleClose = () => {
        this.handleDiscard();
    }

    handlePopUpClose = () => {
        this.setState({
            isOpenPopUp:false
        })
    }

    renderMessage(from, date, message, files) {
        return (
            <>
                <div className="title">
                    <span className="person">
                        {(from || {}).FirstName} {(from || {}).LastName}
                    </span>
                    <span className="date">
                        {formatDateTime(date)}
                    </span>
                </div>
                <div className="content">
                    {multilineText(message)}
                </div>
                <br />
                <div className="d-flex">
                    {files && files.map((o, index) => {
                        const fileKey = `${uploadBucket.messaging}/${o._id}_${o.name}`;
                        if ((/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i).test(o.name)) {
                            return <CustomImage key={index} imageKey={fileKey} />;
                        }
                        return <a href={getS3ImageUrl(fileKey)} download>
                            {o.name}
                        </a>
                    })}
                </div>
            </>
        );
    }

    renderReplyV2() {
        let personId = this.props.match.params.personId;
        let msgId = this.props.match.params.msgId;
        const { sendMessageObj, messageObj } = this.props;
        const { isOpen } = this.state;
        const displayMessageBox = messageObj ?
    <div className="container">
        <Dialog
            fullWidth={true}
            maxWidth="sm"
            open={isOpen}
        >
            <DialogTitle>
               <h2>Reply to the doctor's message</h2> 
            </DialogTitle>
            <DialogContent>
        <div id="message">
        {/* <h3>
            {messageObj.subject}
        </h3> */}
        {this.renderMessage(messageObj.from, messageObj.createdAt, messageObj.message, messageObj.files)}
        </div>
        <form noValidate>
            <div className="form-group">
                <textarea className="form-control" id="message" name="message" rows="4" placeholder="message ..."
                    onChange={this.handleChange}
                    value={sendMessageObj.message}
                    maxlength="500"
                    autoFocus
                >
                </textarea>
                <br />
                <FileUploader multiple={true} onChange={this.changeFile} accept="application/pdf, image/*" />
            </div>
        </form>
            </DialogContent>
            <DialogActions> 
                
            <button className="btn btn-primary mr-2" onClick = {(e) =>this.handleSendReplyByLink(e)}>Send</button>
            <button className="btn btn-primary " onClick={this.handleDiscard} >Close</button>
            </DialogActions>
        </Dialog>
    </div>: "";
        return displayMessageBox;
        

    }

    renderReplyPopUP(){
        const { isReplied } = this.props;
        const { isOpenPopUp } = this.state;
        return(
        <div className="container">
                <Dialog
                    fullWidth={true}
                    maxWidth="sm"
                    open={isOpenPopUp}
                >
                    <DialogTitle>
                    You have already replied to this message
                    </DialogTitle>
                    <DialogContent>
                        <p>
                       Please wait for further instructions from your AskMedication.com doctor. If you have any concerns in the mean time, please email the AskMedication.com customer service at info@southvanmed.com.
                        </p>
                    </DialogContent>
                    <DialogActions>
                    <button className="btn btn-primary ml-2" onClick={this.handlePopUpClose} >Close</button>
                    </DialogActions>
                </Dialog>
            </div>
        )

    }


    render() {
        const { isReplied } = this.props;
        const displayContent = isReplied ? this.renderReplyPopUP():this.renderReplyV2()
        return (
                 <div className="reply">
                 {displayContent}
                </div>    
        )
    }
}


ReplyMessage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    sendMessageObj: PropTypes.object,
    classes: PropTypes.object,
};


function mapStateToProps(state) {
    let { sendMessageObj, isReplied, messageInfo } = state.message;

    if (sendMessageObj === undefined) {
        sendMessageObj = {
            message: ''
        };
    }
    return {
        sendMessageObj,
        isReplied,
        messageObj:messageInfo
    };
}


const temp = compose(
    connect(mapStateToProps),
    withStyles(styles)
)(ReplyMessage);

export { temp as ReplyMessage };

